<div
  class="top d-flex justify-content-between align-content-center flex-column"
>
  <nav class="navbar login-navbar ms-lg-3">
    <img class="login-logo" src="assets/images/CDBlack.png" alt="NCS^ INDORE" />
  </nav>

  <div class="container">
    <div
      class="w-100 row d-flex justify-content-center align-items-center login-component"
    >
      <div class="col-lg-6 left-card">
        <div
          class="card left-card-img shadow-none bg-transparent shadow-none rounded-0 mb-0"
          *ngIf="
            applicationLogo !== 0 && applicationLogo !== undefined;
            else fallbackLogo1
          "
        >
          <img
            src="{{ getDoc(applicationLogo) }}"
            class="applicatin-img"
            alt="application logo"
          />
        </div>

        <ng-template #fallbackLogo1>
          <div
            class="card shadow-none bg-transparent shadow-none rounded-0 mb-0 left-card-img"
          >
            <img
              src="assets/images/CDBlack.png"
              width="500"
              alt="Fallback Logo"
            />
          </div>
        </ng-template>
      </div>

      <div class="col-lg-6 col-md-8 col-sm-10 col-12 righ-card-top">
        <div class="card-body right-card shadow mycardpadding">
          <div>
            <div
              class="text-center w-100 align-content-center application-logo"
              *ngIf="applicationLogo !== 0 && applicationLogo !== undefined"
            >
              <img src="{{ getDoc(applicationLogo) }}" alt="AppLogo" />
            </div>
            <div class="text-center">
              <h1 class="login-application-name">
                {{ appName }}
              </h1>
            </div>

            <!-- Existing sign-in form: unchanged, just hidden once the
                 portal-mode application list is showing -->
            <ng-container *ngIf="!showApplicationSelection">
              <div class="text-center mb-1">
                <h5 class="pb-1">Sign In</h5>
                <form-error [form]="form"></form-error>
              </div>

              <div class="form-body dropdown-pd-none">
                <form class="row" #uiForm="ngForm">
                  <div class="col-12 mt-3">
                    <mat-form-field
                      appearance="outline"
                      class="w-100 no-wrap-asterisk"
                    >
                      <mat-label class="truncate-label">{{
                        loginByOptionsText
                      }}</mat-label>
                      <input
                        matInput
                        [(ngModel)]="form.data['loginId']"
                        type="email"
                        id="loginId"
                        name="loginId"
                        [placeholder]="loginPlaceholder"
                        [readonly]="isreadonly"
                        required
                      />
                      <mat-icon matPrefix class="text-secondary opacity-50"
                        >email</mat-icon
                      >
                    </mat-form-field>
                  </div>

                  <div class="col-12 mt-3">
                    <mat-form-field
                      appearance="outline"
                      class="w-100 no-wrap-asterisk"
                    >
                      <mat-label>Password</mat-label>
                      <input
                        matInput
                        [type]="showPassword ? 'text' : 'password'"
                        id="password"
                        name="password"
                        [placeholder]="'Enter Password'"
                        [(ngModel)]="form.data['password']"
                        required
                        #password="ngModel"
                      />
                      <mat-icon matPrefix class="text-secondary opacity-50"
                        >lock_open</mat-icon
                      >
                      <mat-icon
                        matSuffix
                        (click)="togglePasswordVisibility()"
                        class="cursor-pointer text-secondary opacity-75"
                        [matTooltip]="
                          showPassword ? 'Hide password' : 'Show password'
                        "
                        matTooltipPosition="above"
                      >
                        {{ showPassword ? "visibility" : "visibility_off" }}
                      </mat-icon>
                    </mat-form-field>
                  </div>

                  <div
                    *ngIf="!applicationLoadError"
                    class="col-12 d-flex justify-content-end mb-4 mt-2"
                  >
                    <a
                      routerLink="/forgotpassword"
                      class="text-decoration-none fw-bold"
                      style="color: #f84c54"
                    >
                      Forgot Password?
                    </a>
                  </div>

                  <div class="col-12">
                    <button
                      mat-raised-button
                      color="primary"
                      type="submit"
                      (click)="login()"
                      class="w-100 fat-button shadow-sm"
                      [disabled]="!uiForm.valid || applicationLoadError"
                    >
                      <span class="fs-6 tracking-wider">Sign In</span>
                    </button>
                  </div>

                  <div
                    class="col-12 text-center mt-4"
                    *ngIf="enableUserSignup && !applicationLoadError"
                  >
                    <p class="mb-0 text-muted">
                      Don't have an account yet?
                      <a
                        routerLink="/signup"
                        class="text-decoration-none fw-bold ms-1"
                        style="color: #3f51b5"
                      >
                        Sign up here
                      </a>
                    </p>
                  </div>
                </form>
              </div>
            </ng-container>
           
            <ng-container *ngIf="showApplicationSelection">
              <div class="text-center mb-3">
                <h5 class="pb-1">Choose an Application</h5>
                <p class="text-muted mb-0" *ngIf="!applicationListLoading">
                  Select an application to continue
                </p>
              </div>

              <div
                class="text-center py-4"
                *ngIf="applicationListLoading"
              >
                <span
                  class="spinner-border spinner-border-sm text-primary"
                  role="status"
                  aria-hidden="true"
                ></span>
                <span class="ms-2 text-muted">Loading your applications…</span>
              </div>

              <div
                class="alert alert-danger"
                role="alert"
                *ngIf="applicationListError"
              >
                <i class="material-icons align-middle">error_outline</i>
                {{ applicationListError }}
              </div>
               <div class="text-center mt-3" *ngIf="applicationListError">
                <button
                  mat-stroked-button
                  color="primary"
                  type="button"
                  (click)="backToLoginForm()"
                >
                  Try a different account
                </button>
               </div>
              <div
                class="row"
                *ngIf="!applicationListLoading && userApplications.length > 0"
              >
                <div class="col-12 mt-2">
                  <mat-form-field
                    appearance="outline"
                    class="w-100 no-wrap-asterisk"
                  >
                    <mat-label>Search Application</mat-label>
                    <input
                      matInput
                      type="text"
                      name="applicationSearch"
                      placeholder="Type to search…"
                      [(ngModel)]="applicationSearchText"
                      (ngModelChange)="onApplicationSearchChange($event)"
                      [matAutocomplete]="appAuto"
                    />
                    <mat-icon matPrefix class="text-secondary opacity-50"
                      >apps</mat-icon
                    >
                    <mat-autocomplete
                      #appAuto="matAutocomplete"
                      [displayWith]="displayApplicationName"
                      (optionSelected)="selectApplication($event.option.value)"
                    >
                      <mat-option
                        *ngFor="let app of filteredApplications"
                        [value]="app"
                      >
                        {{ app['applicationName'] }}
                      </mat-option>
                      <mat-option *ngIf="filteredApplications.length === 0" disabled>
                        No matching applications
                      </mat-option>
                    </mat-autocomplete>
                  </mat-form-field>
                </div>
              </div>
            </ng-container>
            <div class="row mt-2">
              <div class="col-lg-12">
                <div class="w-100">
                  <div class="text-center">
                    <span class="login-managed-by">Managed by</span>
                    <span class="org-name">{{ orgName }}</span>
                  </div>
                  <div
                    class="row text-center"
                    *ngIf="
                      orgLogo !== 0 && orgLogo !== undefined;
                      else fallbackLogo
                    "
                  >
                    <a target="_blank" title="Org logo">
                      <img
                        class="org-logo"
                        src="{{ getDoc(orgLogo) }}"
                        alt=""
                      />
                    </a>
                  </div>
                  <ng-template #fallbackLogo>
                    <div class="row text-center">
                      <a target="_blank" title="NCS Indore">
                        <img
                          class="org-logo"
                          src="assets/images/CDBlack.png"
                          width="100px"
                      /></a>
                    </div>
                  </ng-template>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <footer class="footer py-3 mt-auto">
    <div class="container-fluid">
      <p class="text-center mb-0">
        <span class="text-muted">Powered by</span> NCS^ NO-CODE Platform Pvt.
        Ltd.
      </p>
    </div>
  </footer>
</div>

<!-- Modal content -->
<ng-template #content let-modal>
  <div class="modal-header">
    <h5 class="modal-title" id="staticBackdropLabel">Select Role</h5>
    <button
      type="button"
      class="btn-close"
      aria-label="Close"
      (click)="dismissModalFromTS(modal)"
    ></button>
  </div>
  <div class="modal-body">
    <div class="row compact-inputs dropdown-pd-none">
      <div class="col-12 py-3">
        <mat-form-field appearance="outline" class="w-100">
          <mat-label>Select Role</mat-label>
          <mat-select
            (selectionChange)="roleChange($event)"
            [(value)]="selectedRole"
          >
            <mat-option disabled value="undefined">--Select Role--</mat-option>
            <mat-option
              *ngFor="let c of rolelist"
              [value]="c['applicationRoleId']"
            >
              {{ c["applicationRoleName"] }}
            </mat-option>
          </mat-select>
          <mat-icon
            matPrefix
            class="text-secondary opacity-50 icon-compact icon-pd-none px-1"
            >badge</mat-icon
          >
        </mat-form-field>
      </div>
    </div>
  </div>
  <div class="modal-footer">
    <button
      mat-stroked-button
      color="primary"
      type="button"
      (click)="closeModalFromTS(modal)"
    >
      <mat-icon>check</mat-icon>
      Select
    </button>
    <button
      mat-stroked-button
      type="button"
      color="warn"
      (click)="dismissModalFromTS(modal)"
    >
      <mat-icon>close</mat-icon>
      Close
    </button>
  </div>
</ng-template>

<!-- Modal -->
<div
  class="modal fade"
  id="staticBackdrop"
  data-bs-backdrop="static"
  data-bs-keyboard="false"
  tabindex="-1"
  aria-labelledby="staticBackdropLabel"
  aria-hidden="true"
>
  <div class="modal-dialog">
    <div class="modal-content">
      <div class="modal-header">
        <h1 class="modal-title fs-5" id="staticBackdropLabel">Choose Role</h1>
        <button
          type="button"
          class="btn-close"
          data-bs-dismiss="modal"
          aria-label="Close"
        ></button>
      </div>
      <div class="modal-body">
        <select class="form-select" aria-label="Default select example">
          <option selected disabled value="undefined">--Select Role--</option>
          <option *ngFor="let c of rolelist" value="{{ c }}">{{ c }}</option>
        </select>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">
          Close
        </button>
        <button type="button" class="btn btn-primary">Understood</button>
      </div>
    </div>
  </div>
</div>

<!-- Modal content -->
<ng-template #content let-modal>
  <div class="modal-header">
    <h5 class="modal-title" id="staticBackdropLabel">Select Role</h5>
    <button
      type="button"
      class="btn-close"
      aria-label="Close"
      (click)="dismissModalFromTS(modal)"
    ></button>
  </div>
  <div class="modal-body">
    <div class="row compact-inputs dropdown-pd-none">
      <div class="col-12 py-3">
        <mat-form-field appearance="outline" class="w-100">
          <mat-label>Select Role</mat-label>
          <mat-select
            (selectionChange)="roleChange($event)"
            [(value)]="selectedRole"
          >
            <mat-option disabled value="undefined">--Select Role--</mat-option>
            <mat-option
              *ngFor="let c of rolelist"
              [value]="c['applicationRoleId']"
            >
              {{ c["applicationRoleName"] }}
            </mat-option>
          </mat-select>
          <mat-icon
            matPrefix
            class="text-secondary opacity-50 icon-compact icon-pd-none px-1"
            >badge</mat-icon
          >
        </mat-form-field>
      </div>
    </div>
  </div>
  <div class="modal-footer">
    <button
      mat-stroked-button
      color="primary"
      type="button"
      (click)="closeModalFromTS(modal)"
    >
      <mat-icon>check</mat-icon>
      Select
    </button>
    <button
      mat-stroked-button
      type="button"
      color="warn"
      (click)="dismissModalFromTS(modal)"
    >
      <mat-icon>close</mat-icon>
      Close
    </button>
  </div>
</ng-template>
